module.exports = __webpack_public_path__ + "img/budda.0b340548.png";